export const updateNewProject = 'updateNewProject';
export const updateIsAddProjectClicked = 'updateIsAddProjectClicked';
export const updateProject = "updateProject";
export const updateIsEditProjectClicked = "updateIsEditProjectClicked";
export const updateProjectsDataTable = "updateProjectsDataTable";
export const updateIsViewProjectClicked = "updateIsViewProjectClicked";

